import { IMG } from "./services";

const area = (data) => ({ ...data });

export const AREAS = [
  area({
    slug: "شمال-الرياض",
    name: "شمال الرياض",
    h1: "بنشر متنقل في شمال الرياض — نصل إليك أينما كنت",
    title: "بنشر متنقل شمال الرياض | خدمة 24 ساعة — نجم الإطار",
    description: "بنشر متنقل في شمال الرياض: العليا، الصحافة، الياسمين، النرجس، الملقا وحطين. إصلاح بنشر وتغيير كفرات وترصيص في موقعك. واتساب 0538644740",
    image: IMG.riyadh,
    alt: "أفق مدينة الرياض ومبانٍ حديثة في منطقة شمال الرياض",
    districts: ["العليا", "الصحافة", "الياسمين", "النرجس", "الملقا", "حطين", "الوادي", "الغدير"],
    roads: ["طريق الملك فهد", "طريق الملك خالد (المطار)", "طريق أنس بن مالك", "طريق التخصصي"],
    intro: [
      "شمال الرياض من أكثر مناطق المدينة حركةً وازدحاماً: مولات العليا، مقرّات العمل، والأحياء الراقية الممتدة من الصحافة إلى حطين. وكثرة الحركة تعني احتمالاً أكبر لثقب مفاجئ في الكفر أو نزول ضغط تلاحظه صباحاً قبل دوامك.",
      "فريق نجم الإطار يخدم شمال الرياض على مدار الساعة: تصل سيارة البنشر المتنقل إلى موقعك في العليا أو الصحافة أو حطين أو الملقا، وتنجز الإصلاح أو التغيير في المكان نفسه — قبل الدوام، بعده، أو في منتصف الليل.",
    ],
    points: [
      "وصول سريع إلى أحياء العليا والصحافة والياسمين والنرجس والملقا وحطين",
      "خدمة على الطرق الرئيسية: الملك فهد، المطار، أنس بن مالك والتخصصي",
      "تركيب كفرات وجنوط في مواقف مجمعات العمل والسكن",
      "برمجة حساسات TPMS لسيارات الشمال الفخمة حديثة الموديل",
    ],
    faqs: [
      { q: "هل تصلون إلى أحياء حطين والملقا؟", a: "نعم، نغطي شمال الرياض كاملاً بما يشمل حطين والملقا والوادي والغدير والأحياء الملاصقة لها." },
      { q: "هل يمكن إنجاز الخدمة قبل الدوام؟", a: "نعم، خدمتنا تعمل من الساعات الأولى للفجر، فتستطيع إنجاز صيانة إطارك قبل بداية دوامك." },
    ],
  }),
  area({
    slug: "جنوب-الرياض",
    name: "جنوب الرياض",
    h1: "بنشر متنقل في جنوب الرياض — خدمة على الطريق وفي بيتك",
    title: "بنشر متنقل جنوب الرياض | الشفا والعزيزية وبدر — نجم الإطار",
    description: "بنشر متنقل في جنوب الرياض: الشفا، العزيزية، الدار البيضاء، بدر والمروة. إصلاح بنشر وتغيير كفرات 24 ساعة في موقعك. واتساب 0538644740",
    image: IMG.roadside,
    alt: "فني بنشر متنقل يعمل على كفر سيارة في جنوب الرياض",
    districts: ["الشفا", "العزيزية", "الدار البيضاء", "بدر", "المروة", "الحزم"],
    roads: ["الدائري الجنوبي", "شارع الستين", "طريق مكة المكرمة"],
    intro: [
      "جنوب الرياض منطقة حركة لوجستية وتجارية: سوقي الشفا والجبيلة القريبة، المزارع، والمسارات التي تربط الرياض بمخرجاتها الجنوبية. والحركة الكثيفة على الدائري الجنوبي وشارع الستين تعني أن تعطل الكفر هنا شائع — خاصة على سيارات النقل والبيك أب التي تحمل حمولات ثقيلة.",
      "نخدم جنوب الرياض بفريق مجهز يصل إلى موقعك في الشفا أو العزيزية أو بدر أو الدار البيضاء: إصلاح البنشر على حافة الطريق، تغيير الكفرات في مواقف البيوت، أو تجهيز إطارات السيارات التجارية في مكان عملها.",
    ],
    points: [
      "وصول سريع إلى الشفا والعزيزية والدار البيضاء وبدر والمروة",
      "خدمة على الدائري الجنوبي وشارع الستين وطريق مكة المكرمة",
      "خبرة في كفرات البيك أب والسيارات التجارية ذات الحمولة العالية",
      "خدمة ليلية كاملة — مناسبة لأسواق الجنوب ووقت ذروتها",
    ],
    faqs: [
      { q: "هل تصلون إلى منطقة الشفا؟", a: "نعم، الشفا من أهم مناطق تغطيتنا في جنوب الرياض، ونصل إلى مواقف البيوت والأسواق والمشاريع في المكان نفسه." },
      { q: "هل تتعاملون مع كفرات البيك أب؟", a: "نعم، نوفر ونركب كفرات البيك أب والحمولة الثقيلة مع الموازنة المناسبة لها في موقعك." },
    ],
  }),
  area({
    slug: "شرق-الرياض",
    name: "شرق الرياض",
    h1: "بنشر متنقل في شرق الرياض — من الروضة إلى قرطبة",
    title: "بنشر متنقل شرق الرياض | الروضة والنسيم وغرناطة — نجم الإطار",
    description: "بنشر متنقل في شرق الرياض: الروضة، النسيم، غرناطة، قرطبة والريان. تغيير كفرات وإصلاح بنشر وترصيص في موقعك. واتساب 0538644740",
    image: IMG.tireWheel,
    alt: "تركيب كفر جديد في شرق الرياض مع أجهزة الموازنة",
    districts: ["الروضة", "النسيم", "غرناطة", "قرطبة", "الريان", "الحمراء", "الشهداء"],
    roads: ["الدائري الشرقي (طريق الملك عبدالله)", "طريق الخرج", "شارع عثمان بن عفان"],
    intro: [
      "شرق الرياض من أعلى المناطق كثافةً سكانية: أحياء الروضة والنسيم وغرناطة وقرطبة تمتد على مساحة واسعة من الدوائر السكنية، ومخارجها على طريق الخرج والدائري الشرقي تتحرك باستمرار نحو المدن الشرقية. كل هذا التنقل يجعل صيانة الإطارات هنا حاجة يومية لا موسمية.",
      "نخدم شرق الرياض بفريق يتحرك داخل الأحياء نفسها: إلى بيتك في الروضة، موقف عملك في قرطبة، أو حافة الطريق إذا تعطل كفرك على الدائري الشرقي. الفني يصل بمعدات فك وتركيب وموازنة كاملة وينجز العمل في موقعك.",
    ],
    points: [
      "تغطية الروضة والنسيم وغرناطة وقرطبة والريان والحمراء",
      "خدمة على الدائري الشرقي وطريق الخرج والمسارات الداخلية",
      "إصلاح بنشر سريع في أوقات الذروة الصباحية والمسائية",
      "كفرات اقتصادية وعائلية تناسب كثافة السكان في الشرق",
    ],
    faqs: [
      { q: "هل تغطون حي النسيم وغرناطة؟", a: "نعم، نغطي شرق الرياض كاملاً بما يشمل النسيم وغرناطة وقرطبة والريان وكل الأحياء الملاصقة." },
      { q: "ماذا لو تعطل الكفر على الدائري الشرقي؟", a: "وقف في المكان الآمن الأبعد عن حركة السيارات، ثم راسلنا على واتساب أو أرسل موقعك — وسيتحرك الفني إلى نقطة وقوفك مباشرة." },
    ],
  }),
  area({
    slug: "غرب-الرياض",
    name: "غرب الرياض",
    h1: "بنشر متنقل في غرب الرياض — من عرقة إلى السويدي",
    title: "بنشر متنقل غرب الرياض | السويدي وعرقة وظهرة لبن — نجم الإطار",
    description: "بنشر متنقل في غرب الرياض: السويدي، عرقة، ظهرة لبن والطريف. إصلاح بنشر وتغيير كفرات وترصيص في موقعك 24 ساعة. واتساب 0538644740",
    image: IMG.flat,
    alt: "كفر سيارة يحتاج إلى إصلاح في غرب الرياض",
    districts: ["السويدي", "عرقة", "ظهرة لبن", "الطريف", "المروة الغربية"],
    roads: ["طريق الدرعية", "الدائري الغربي", "طريق العرجاء"],
    intro: [
      "غرب الرياض يجمع بين الأحياء العريقة مثل السويدي والأحياء الحديثة الممتدة نحو عرقة وظهرة لبن، ومحاور مهمة مثل طريق الدرعية الذي يربط المدينة بمسارها الترفيهي الشمالي الغربي. المسافات هنا أطول، وقيادة المسافات الطويلة تستهلك الكفرات وتكشف عن أي ضعف في ضغطها.",
      "نخدم غرب الرياض بخدمة متنقلة كاملة: فحص إطارات في بيتك قبل رحلتك، إصلاح بنشر في حي السويدي، تركيب كفرات جديدة في عرقة، أو ترصيص يعالج اهتزاز المقود — كل ذلك في موقعك وفي الوقت الذي يناسبك.",
    ],
    points: [
      "تغطية السويدي وعرقة وظهرة لبن والطريف وأحياء الغرب الممتدة",
      "خدمة على طريق الدرعية والدائري الغربي",
      "فحص إطارات كامل قبل الرحلات والسفر",
      "مواعيد مسائية تصلح لذروة العودة إلى المنزل",
    ],
    faqs: [
      { q: "هل تصلون إلى عرقة وظهرة لبن؟", a: "نعم، غرب الرياض من مناطق تغطيتنا الأساسية، ونصل إلى عرقة وظهرة لبن والسويدي وأي حي ملاصق لها." },
      { q: "هل أستطيع فحص إطاراتي قبل السفر؟", a: "نعم، اطلب زيارة فحص وسنصل إلى بيتك لفحص التايد والضغط والتشقق وضبط الإطارات قبل رحلتك." },
    ],
  }),
  area({
    slug: "وسط-الرياض",
    name: "وسط الرياض",
    h1: "بنشر متنقل في وسط الرياض — في قلب المدينة وفي مواعيد ضيقة",
    title: "بنشر متنقل وسط الرياض | الديرة والصفا والعليا العامة — نجم الإطار",
    description: "بنشر متنقل في وسط الرياض: الديرة، الصفا، المصل، السلطانة والعليا العامة. إصلاح وتغيير كفرات في موقعك. واتساب 0538644740",
    image: IMG.van,
    alt: "فانيلا بنشر متنقل نجم الإطار في وسط الرياض",
    districts: ["الديرة", "الصفا", "المصل", "السلطانة", "الكرامة", "العريجاء"],
    roads: ["طريق الملك فهد", "شارع العليا العام", "شارع التحلية"],
    intro: [
      "وسط الرياض هو قلب المدينة وأكثرها ضغطاً على السيارات: الشوارع القديمة الضيقة في الديرة والكرامة، مواقف مزدحمة حول الأسواق والجهات الحكومية، وحركة متواصلة على طريق الملك فهد وشارع العليا. المواقف هنا ضيقة، وأصحاب السيارات لا يستطيعون ترك سياراتهم ساعات في ورشة — وهذا ما صُممت خدمتنا له.",
      "نخدم وسط الرياض بحركة سريعة داخل الأحياء: إصلاح بنشر في موقف ضيق، تغيير كفر أمام مواجهتك، أو ضبط هواء وضغط قبل انطلاقتك. الفني يصل إلى نقطة سيارتك مباشرة — حتى لو كانت في موقف تحت الأرض أو في شارع فرعي.",
    ],
    points: [
      "تغطية الديرة والصفا والمصل والسلطانة والكرامة والعريجاء",
      "وصول إلى المواقف المغطاة والشوارع الفرعية الضيقة",
      "خدمة سريعة تناسب ضغط الوسط التجاري والحكومي",
      "أرقام هواء وضغط مضبوطة حسب مواصفات سيارتك",
    ],
    faqs: [
      { q: "هل تصلون إلى المواقف المغطاة؟", a: "نعم، فنيناً مجهز بمعدات رفع محمولة تصلح للمواقف المغطاة والشوارع الضيقة في وسط الرياض." },
      { q: "هل تخدمون منطقة الديرة؟", a: "نعم، نصل إلى الديرة والكرامة والصفا وكل الأحياء القريبة من وسط المدينة في مواعيد مرنة." },
    ],
  }),
];

export const getArea = (slug) => AREAS.find((a) => a.slug === slug);
